import {
    request
} from '../http';
import domain from '../domain';

var payService = function() {
    if (domain.env === 'online') {
        this.domain = "//pay.51tiangou.com";
    } else {
        this.domain = "//pay." + domain.env + ".66buy.com.cn";
    }
};

/**
 * 支付成功通知
 * @param params
 */
payService.prototype.successNotify = function(params) {
    params.error = function() {};
    params.tgError = function() {};
    this._serviceAjaxCom("/callback/payQueryStatus", params); //TODO  这个接口地址没确定
};

payService.prototype._serviceAjaxCom = function(url, params) {
    params.url = this.domain + url;
    request(params);
};
/**
 * 开卡
 * @param params
 */
payService.prototype.personOpen = function(params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/webank/open", params);
};
//点金计划
payService.prototype.goldPointing = function(params) {
  var that = this;
  params.type = 'POST';
  that._serviceAjaxCom("/pay/result/goldPointing", params);
};
/**
 * 绑定银行卡
 * @param params
 */
payService.prototype.bindBankCard = function(params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/webank/bindBankCard", params);
};
/**
 * 解除绑定银行卡
 * @param params
 */
payService.prototype.unBindBankCard = function(params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/webank/unBindBankCard", params);
};
/**
 * 查询银行卡列表
 * @param params
 */
payService.prototype.queryBindBankCards = function(params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/webank/queryBindBankCards", params);
};
/**
 * 修改手机号码
 * @param params
 */
payService.prototype.changePhoneNumber = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/modifyPhoneNo", params); 
};

/**
 * 修改密码
 * @param params
 */
payService.prototype.pwdChange = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/pwdChange", params); 
};

/**
 * 重置密码
 * @param params
 */
payService.prototype.pwdReset = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/pwdReset", params);
};

/**
 * 查询手机号
 * @param params
 */
payService.prototype.queryPersonPhoneNo = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/queryPersonPhoneNo", params);
};
/**
 * 修改手机号
 * @param params
 */
payService.prototype.modifyPhoneNo = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/modifyPhoneNo", params); 
};

/**
 * 查询余额
 * @param params
 */
payService.prototype.queryBalance = function(params = {}) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/queryBalance", params);  
};

/**
 * 开户
 * @param params
 */
payService.prototype.personOpen = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/open", params);  
};

/**
 * 查询绑卡列表
 * @param params
 */
payService.prototype.queryBindBankCards = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/queryBindBankCards", params);  
};

/**
 * 充值
 * @param params
 */
payService.prototype.recharge = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/recharge", params);  
};

/**
 * 绑卡
 * @param params
 */
payService.prototype.bindBankCard = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/webank/bindBankCard", params);  
};

/**
 * 银联无人店获取签名
 * @param params
 */
payService.prototype.getSign = function(params) {
    var that = this;
    params.type = 'get';
    return that._serviceAjaxCom("/publics/selfStore/sign", params);  
};

/**
 * 商品详情 - 确认订单弹窗里调的获取支付方式接口
 * @param params
 */
payService.prototype.preOrderGetCashiers = function(params) {
    var that = this;
    params.type = 'get';
    return that._serviceAjaxCom("/publics/cashiers/noOrder/getCashiers", params);
};

export default new payService();